import React from "react";
import { ValueTableRuleBuilder } from "../ValueTableRuleBuilder";
import { getValueTableDate } from "../Testing/TestDataSetup";
import { StoryNode } from "../../../../CommonUI/StoryBook/StoryData";

export const ValueTableDateStories = [
    new StoryNode(
        () => {
            let ruleDefinition = getValueTableDate();
            ruleDefinition.rows[0].cells[0].values = "1990-01-07";

            return <ValueTableRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Value Table",
        "Date",
        "Value"
    ),

    new StoryNode(
        () => {
            let ruleDefinition = getValueTableDate();
            ruleDefinition.rows[0].cells[0].values = ["1990-01-07", "1990-02-01", "1990-03-01"];

            return <ValueTableRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Value Table",
        "Date",
        "List"
    ),
];
